export default {
  fields: {
    sales: {
      label: 'Myynti',
    },
    gift_cards_sales: {
      label: 'Lahjakorttimyynti',
    },
    average_order_value: {
      label: 'Keskimääräinen tilausarvo',
    },
    savings: {
      label: 'Säästöt kolmannen osapuolen maksuissa',
    },
    reservations: {
      label: 'Varaukset',
    },
    sales_from_email: {
      label: 'Myynti sähköpostista',
    },
    sales_from_google_seo: {
      label: 'Myynti Google SEO:sta',
    },
    sales_from_google_business_profile: {
      label: 'Myynti Google Businessista',
    },
    sales_from_google_ads: {
      label: 'Myynti Google Adsista',
    },
    sales_from_flyers: {
      label: 'Myynti mainoslehtisistä',
    },
    sales_from_social_media: {
      label: 'Myynti sosiaalisesta mediasta',
    },
    sales_from_facebook_ads: {
      label: 'Myynti Facebook Adsista',
    },
    tips: {
      label: 'Tipit',
    },
    new_customers: {
      label: 'Uudet asiakkaat',
    },
    returning_customers: {
      label: 'Palaavat asiakkaat',
    },
    new_visitors: {
      label: 'Uudet kävijät',
    },
    new_followers: {
      label: 'Uudet seuraajat',
    },
    total_followers: {
      label: 'Seuraajat yhteensä',
    },
    delivered_messages: {
      label: 'Toimitetut viestit',
    },
    average_open_rate: {
      label: 'Keskimääräinen sähköpostin avausprosentti',
    },
    average_click_rate: {
      label: 'Keskimääräinen klikkausprosentti',
    },
    website_visitors_from_email: {
      label: 'Verkkosivuston kävijät sähköpostista',
    },
    sales_from_google_business: {
      label: 'Myynti Google Businessista',
    },
    total_reservations: {
      label: 'Varaukset',
    },
    website_visitors_from_google_seo: {
      label: 'Verkkosivuston klikkaukset Google SEO:sta',
    },
    website_clicks_from_google_business: {
      label: 'Verkkosivuston klikkaukset Google Businessista',
    },
    website_visitors_from_google_ads: {
      label: 'Verkkosivuston klikkaukset Google Adsista',
    },
    website_visitors_from_social_media: {
      label: 'Verkkosivuston klikkaukset sosiaalisesta mediasta',
    },
    calls_from_google_ads: {
      label: 'Puhelut Google Adsista',
    },
    directions_from_google_ads: {
      label: 'Reittiohjeet Google Adsista',
    },
    google_seo_orders_count: {
      label: 'Google SEO',
    },
    google_business_orders_count: {
      label: 'Google Business',
    },
    google_ads_orders_count: {
      label: 'Google Ads',
    },
    facebook_ads_orders_count: {
      label: 'Facebook Ads',
    },
    social_media_orders_count: {
      label: 'Sosiaalinen media',
    },
    flyer_orders_count: {
      label: 'Mainoslehtiset',
    },
    email_orders_count: {
      label: 'Sähköpostit',
    },
    other_orders_count: {
      label: 'Muut',
    },
    gmv: {
      label: 'GMV',
    },
    gift_cards_gmv: {
      label: 'Lahjakortit',
    },
    net_billed_revenue: {
      label: 'Laskutettu liikevaihto (NET)',
    },
    net_billed_revenue_subscription: {
      label: 'Laskutettu tilausliikevaihto',
    },
    net_billed_revenue_service_fee: {
      label: 'Laskutetut palvelumaksutulot',
    },
    net_billed_revenue_external_delivery_platform_fee: {
      label: 'Laskutetut toimitusmaksutulot',
    },
    net_billed_revenue_other: {
      label: 'Laskutetut palvelumaksutulot (service charges)',
    },
    net_billed_revenue_external_delivery_passthrough_fee: {
      label: 'Laskutettu toimitus – läpikulkumaksu',
    },
    net_billed_revenue_platform_processing_fee: {
      label: 'Laskutetut alustan käsittelymaksutulot',
    },
    gross_cash_income: {
      label: 'Käteistulot (brutto)',
    },
    gross_cash_income_subscription: {
      label: 'Käteistulot tilauksista (subscriptions)',
    },
    gross_cash_income_service_fee: {
      label: 'Käteistulot palvelumaksuista',
    },
    gross_cash_income_external_delivery_platform_fee: {
      label: 'Käteistulot toimitusmaksuista',
    },
    gross_cash_income_other: {
      label: 'Käteistulot palvelumaksuista (service charges)',
    },
    gross_cash_income_external_delivery_passthrough_fee: {
      label: 'Käteistulot toimituksen läpikulkumaksuista',
    },
    gross_cash_income_platform_processing_fee: {
      label: 'Käteistulot alustan käsittelymaksuista',
    },
    net_cash_income: {
      label: 'Käteistulot (netto)',
    },
    net_cash_income_subscription: {
      label: 'Käteistulot tilauksista (subscriptions)',
    },
    net_cash_income_service_fee: {
      label: 'Käteistulot palvelumaksuista',
    },
    net_cash_income_external_delivery_platform_fee: {
      label: 'Käteistulot toimitusmaksuista',
    },
    net_cash_income_other: {
      label: 'Käteistulot palvelumaksuista (service charges)',
    },
    net_cash_income_external_delivery_passthrough_fee: {
      label: 'Käteistulot toimituksen läpikulkumaksuista',
    },
    net_cash_income_platform_processing_fee: {
      label: 'Käteistulot alustan käsittelymaksuista',
    },
    manual_connect_transfers: {
      label: 'Hyvitetty ravintoloille',
    },
    processing_fees: {
      label: 'Käsittelymaksut',
    },
    processing_fees_stripe: {
      label: 'Käsittelymaksut (Stripe)',
    },
    processing_fees_paypal: {
      label: 'Käsittelymaksut (PayPal)',
    },
    rejected_orders: {
      label: 'Hylätyt tilaukset',
    },
    rejected_orders_amount: {
      label: 'Hylättyjen tilausten summa',
    },
    rejected_orders_count: {
      label: 'Hylättyjen tilausten määrä',
    },
    rejected_orders_rate: {
      label: 'Hylättyjen tilausten osuus',
    },
    rejected_orders_rate_breakdown: {
      label: 'Hylättyjen tilausten osuuden erittely',
    },
    orders: {
      label: 'Tilaukset',
    },
    total_orders: {
      label: 'Tilaukset yhteensä',
    },
    pickup_orders_rate: {
      label: 'Nouto­tilausten osuus',
    },
    delivery_orders_rate: {
      label: 'Toimitustilausten osuus',
    },
    other_orders_rate: {
      label: 'Muiden tilausten osuus',
    },
    customers: {
      label: 'Asiakkaat yhteensä',
    },
    customers_auth_state: {
      label: 'Asiakkaan tunnistautumistila',
    },
    website_reservations: {
      label: 'Verkkosivuvaraukset',
    },
    google_reservations: {
      label: 'Google-varaukset',
    },
    companies: {
      label: 'Yritykset',
    },
    live_companies: {
      label: 'Aktiiviset ravintolat',
    },
    live_companies_percentage: {
      label: 'Aktiivisten ravintoloiden osuus',
    },
    setup_packages_breakdown: {
      label: 'Käyttöönottopaketit',
    },
    setup_packages_billing_mode_breakdown: {
      label: 'Käyttöönottopaketit laskutuslähteen mukaan',
    },
    crossed_sales_level_this_month: {
      label: 'Myyntitaso ylitetty tässä kuussa',
    },
    crossed_sales_level_total: {
      label: 'Myyntitaso ylitetty yhteensä',
    },
    crossed_sales_level_percentage: {
      label: 'Myyntitason ylitysprosentti',
    },
    has_delivery: {
      label: 'Oma toimitus',
    },
    has_only_pickup: {
      label: 'Vain nouto',
    },
    has_storefront: {
      label: 'Storefront käytössä',
    },
    has_storefront_percentage: {
      label: 'Storefrontin osuus',
    },
    use_external_delivery: {
      label: 'Ulkoinen toimitus',
    },
    crossed_sales: {
      label: 'Ylitti {{value}} myynnin',
    },
    restaurant_partners: {
      label: 'Ravintolakumppanit',
    },
    registered_restaurants: {
      label: 'Rekisteröityneet ravintolat',
    },
    signed_restaurants: {
      label: 'Sopimuksen tehneet ravintolat',
    },
    use_reservations: {
      label: 'Käyttää varauksia',
    },
    number: {
      label: 'Määrä',
    },
    restaurants_percentage: {
      label: 'Ravintoloiden osuus',
    },
    crossed_sales_level: {
      label: 'Myyntitaso ylitetty',
    },
    order_method: {
      label: 'Tilaustapa',
    },
    own_delivery: {
      label: 'Oma toimitus',
    },
    only_pickup: {
      label: 'Vain nouto',
    },
    storefront: {
      label: 'Storefront',
    },
    sales_tiers: {
      label: 'Myyntitasot',
    },
    new_pricing_adoption_rate: {
      label: 'Uuden hinnoittelun käyttöönottoaste',
    },
    mobile_app_attach_rate: {
      label: 'Mobiilisovelluksen käyttöönottoaste',
    },
    mobile_app_setup_fee_breakdown: {
      label: 'Mobiilisovelluksen käyttöönottomaksu valittu',
    },
    first_delivery: {
      label: 'Uber (First Delivery)',
    },
    wolt_drive: {
      label: 'Wolt',
    },
    uber_drive: {
      label: 'Uber',
    },
    delivery_quotes_count: {
      label: 'Toimitustarjousten määrä',
    },
    deliveries_count: {
      label: 'Toimitusten määrä',
    },
    delivery_conversion: {
      label: 'Toimitusten konversioaste',
    },
    delivery_quotes_provider_breakdown: {
      label: 'Toimitustarjousten erittely palveluntarjoajittain',
    },
    deliveries_provider_breakdown: {
      label: 'Toimitusten erittely palveluntarjoajittain',
    },
    delivery_distance_breakdown: {
      label: 'Toimitusmatkan erittely',
    },
    total_delivered: {
      label: 'Toimitetut viestit',
    },
    website_visitors_from_google_business_profile: {
      label: 'Verkkosivuklikkaukset Google Businessista',
    },
    google_business_impressions: {
      label: 'Näyttökerrat Google Businessista',
    },
    google_business_website_clicks: {
      label: 'Verkkosivuklikkaukset Google Businessista',
    },
    google_ads_impressions: {
      label: 'Näyttökerrat Google Ads',
    },
    google_ads_clicks: {
      label: 'Klikkaukset Google Ads',
    },
    google_ads_phone_calls: {
      label: 'Puhelut Google Ads',
    },
    google_ads_directions: {
      label: 'Reittiohjeet Google Ads',
    },
    google_ads_absolute_top_impression_percentage: {
      label: 'Keskimääräinen absoluuttinen ylimmän sijan näyttöprosentti Google Ads',
    },
    google_ads_average_cpc: {
      label: 'Keskimääräinen klikkauskohtainen hinta Google Ads',
    },
    google_ads_conversions_from_interactions_rate: {
      label: 'Keskimääräinen konversioiden osuus vuorovaikutuksista Google Ads',
    },
    website_visits: {
      label: 'Verkkosivukäynnit',
    },
    website_visitors: {
      label: 'Verkkosivukävijät',
    },
    companies_with_activated_reservations: {
      label: 'Ravintolat, joilla varaukset aktivoitu',
    },
    online_orders_count: {
      label: 'Verkkotilaukset',
    },
    cash_orders_count: {
      label: 'Verkkotilaukset',
    },
    cash_sales: {
      label: 'Käteismyynti',
    },
    online_sales: {
      label: 'Verkkomyynti',
    },
    payouts: {
      label: 'Maksut',
    },
    last_payout_amount: {
      label: 'Viimeisin maksu',
    },
    pending_payout_amount: {
      label: 'Käsiteltävänä',
    },
    future_payout_amount: {
      label: 'Käytettävissä tuleviin maksuihin',
    },
    mobile_app_average_order_value: {
      label: 'Keskimääräinen tilausarvo sovelluksessa',
    },
    mobile_app_gmv: {
      label: 'Sovelluksen kokonaismyynti',
    },
    mobile_app_gmv_percentage: {
      label: 'Sovelluksen osuus liikevaihdosta %',
    },
    mobile_app_downloads: {
      label: 'Sovelluslataukset yhteensä',
    },
    mobile_app_orders_count: {
      label: 'Sovelluksen tilaukset yhteensä',
    },
    net_billed_revenue_gift_cards: {
      label: 'Laskutetut lahjakorttitulot',
    },
    gross_cash_income_gift_cards: {
      label: 'Käteistulot lahjakorteista',
    },
    net_cash_income_gift_cards: {
      label: 'Käteistulot lahjakorteista',
    },
    platform_processing_fees: {
      label: 'Alustan käsittelymaksut',
    },
  },
};
